import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAlignLeftRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-align-left-right, padding"} maskId="square-filled-radius-0-stroke-1-IconLayoutAlignLeftRight"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 17H8V7H7V17ZM16 7V17H17V7H16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutAlignLeftRight;
